import { filter, isEmpty, map, forEach } from "lodash";
import * as moment from "moment";
import * as DateTypes from "../DataTypes/dateTypes";

export function reformatDate(data: DateTypes.IPowerTimeMonth) {
    var year = data.year;
    var month = data.month < 10 ? "0" + data.month : data.month;
    var availability: DateTypes.Availability = {};

    var dates = filter(data.dayEntries, function (n) {
        return !isEmpty(n.timeEntries);
    });

    map(dates, function (n) {
        n.number = Number(n.number) < 10 ? "0" + n.number : n.number;
        n.date = year + "-" + month + "-" + n.number;
        delete n.number;
        n.availableTimes = n.timeEntries;
        delete n.timeEntries;
    });

    forEach(dates, function (i, key) {
        map(i.availableTimes, function (n) {
            n.hour = n.start;
            n.id = n.appointmentId ? n.appointmentId : i.date + " " + n.start;
            delete n.start;
        });
    });

    availability[year] = {};
    availability[year][month] = dates;

    return availability;
}

function getLocalMoment(timeEntry: DateTypes.IPowerTimeEntry): moment.Moment {
    return moment(timeEntry.dateTimeOffset);
}

function buildDaysCollection(
    days: DateTypes.IPowerTimeDay[],
    requestedMonth: number,
    minutesAhead: number
): DateTypes.IPowerTimeDay[] {
    if (days.length === 0) {
        return [];
    }

    if (days.length > 1) {
        console.log("too many days");
        return;
    }
    var daysCollection: DateTypes.IPowerTimeDay[] = [];
    var times = days[0].timeEntries;
    var newDays: Record<number, DateTypes.IPowerTimeEntry[]> = {};
    for (let i = 0; i < times.length; i++) {
        const item = times[i];
        if (!item.dateTimeOffset) {
            console.log("No offset");
            return;
        }
        const localMoment = getLocalMoment(item);
        const number: number = localMoment.date(); // day number
        const localMonth: number = localMoment.month() + 1; // month enumeration start from zero
        const isInThePast = localMoment.isBefore(moment().add(minutesAhead, "minutes"));
        if (requestedMonth !== localMonth || isInThePast) continue; // skip

        const localTime = localMoment.format("HH:mm:ss");

        if (!newDays[number]) {
            newDays[number] = [];
        }
        var itemCopy: DateTypes.IPowerTimeEntry = { ...item };
        itemCopy.start = localTime;
        newDays[number].push(itemCopy);
    }
    var keys = Object.keys(newDays);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        daysCollection.push({ number: Number(key), timeEntries: newDays[key] });
    }
    return daysCollection;
}

export function reformatDateTimezone(data: DateTypes.IPowerTimeMonth) {
    var year = data.year;
    var month = data.month < 10 ? "0" + data.month : data.month;
    var availability: DateTypes.Availability = {};

    var dates = filter(data.dayEntries, function (n) {
        return !isEmpty(n.timeEntries);
    });

    // rebuild days collection according to timezone
    dates = buildDaysCollection(dates, data.month, data.minutesAhead);

    map(dates, function (n) {
        n.number = Number(n.number) < 10 ? "0" + n.number : n.number;
        n.date = year + "-" + month + "-" + n.number;
        delete n.number;
        n.availableTimes = n.timeEntries;
        delete n.timeEntries;
    });
    const getDateAndTime = (day: DateTypes.IPowerTimeDay, time: DateTypes.IPowerTimeEntry): string => {
        //console.log("offset: ", time.dateTimeOffset)
        const result = day.date + " " + time.start;
        //console.log("result: ", result)
        return result;
    };
    forEach(dates, function (i, key) {
        map(i.availableTimes, function (n) {
            n.hour = n.start;
            n.id = n.appointmentId ? n.appointmentId : getDateAndTime(i, n);
            delete n.start;
        });
    });

    availability[year] = {};
    availability[year][month] = dates;

    return availability;
}
